import React from "react";
import Header, { Grid } from "semantic-ui-react";
import { connect } from "react-redux";

import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";
import { Box } from "./components";
import Chart from "../../components/Chart";

const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;

const barChartTemplate = {
  lang: {
    thousandsSep: ","
  },
  chart: {
    backgroundColor: "none",
    marginLeft: 45,
    height: 382,
    fontFamily: "Roboto",
    fontWeight: 400,
    spacingTop: 10,
    type: "line",
    style: {
      paddingBottom: 10,
      fontSize: 16
    }
  },
  title: {
    useHTML: true,
    style: {
      color: "#414042",
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "Roboto"
    },
    text: null,
    align: "left",
    x: -5,
    y: 5
  },
  xAxis: {
    categories: [],
    labels: {
      style: {
        fontSize: "8px"
      }
    }
  },
  yAxis: [
    {
      title: {
        text: null
      }
    }
  ],
  legend: {
    itemStyle: {
      fontWeight: "400",
      fontSize: "13px",
      fontFamily: "Roboto",
      color: "#414042"
    }
  },
  labels: {
    items: []
  },
  series: [],
  credits: {
    enabled: false
  }
};

class OverView extends React.Component {
  componentDidMount() {
    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.loadInitialAnalyticsState(start_date, end_date);
  }
  render() {
    const {
      net_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category_chart,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category
    } = this.props;

    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    // salesByStore['title']['text'] = 'SALES BY STORE';
    salesByStore["xAxis"]["categories"] = sales_by_store["categories"];
    salesByStore["series"] = sales_by_store["series"];
    const secondary_yAxis = {
      gridLineWidth: 0,
      title: {
        text: null
      },
      opposite: true
    };
    salesByStore["yAxis"].push(secondary_yAxis);
    return (
      <div className="tabs-component-container">
        <h5 className="overview-heading">LOYALTY OVERVIEW</h5>
        <Grid columns={4} className="grid-container">
          <Box
            componentData={{
              header: "Loyalty Customers",
              value: "1,103",
              percent: "1"
            }}
          />
          <Box
            componentData={{
              header: "Rewards Issued",
              value: "35",
              percent: "1"
            }}
          />
          <Box
            componentData={{ header: "Redemptions", value: "22", percent: "1" }}
          />
          <Box
            componentData={{
              header: "Best Loyalty Programe",
              bestProgramme: "facebook"
            }}
          />
        </Grid>

        <Grid columns={2} className="grid-container">
          <Chart title="VISITS" data={salesByStore} />
          <Chart title="REWARDS AND REDEMPTIONS" data={salesByStore} />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return getSelectorAnalytics(state);
};

export default connect(mapStateToProps, { loadInitialAnalyticsState })(
  OverView
);



// WEBPACK FOOTER //
// ./src/containers/Loyalty/OverView.js